const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            archive:            'Arquivo',
            avaiable:           'Disponível até',
            abstract:           'Subtítulo',
            cancel:             'Cancelar', back: 'Voltar',
            close:              'Fechar',
            content:            'Imprensa',
            content_add:        'Adicionar bloco',
            choose_category:    'Pressione ENTER para escolher a categoria',
            content_edit:       'Editar conteúdo',
            content_new:        'Novo conteúdo',
            content_list:       'Lista de imprensa',
            dates:              'Datas',
            date_creation:      'Criação',
            date_avaiable:      'Disponível até',
            date_publication:   'Publicação',
            date_last_update:   'Última atualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar registo',
            delete_text:        'Continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            description:        'Descrição',
            draft:              'Rascunho',
            doc_choose:         'Carregar PDFs',
            edit:               'Editar',
            edit_title:         'Editar registo',
            edit_text:          'Continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao atualizar registo!',
            edit_success:       'Registo atualizado com sucesso!',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            layout:             'Tipo',
            multimedia:         'Multimédia',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            news:               'Imprensa',
            news_add:           'Adicionar bloco',
            news_edit:          'Editar artigo',
            news_new:           'Novo artigo',
            news_list:          'Lista de imprensa',
            image:              'Imagem em destaque',
            images:             'Imagens',
            image_choose:       'Carregar imagens',
            insert_title:       'Novo registo',
            insert_text:        'Continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            page_config:        'Configuração da Página',
            page_parent:        'Parent',
            pages:              'Páginas',
            pdf_documents:      'Documentos PDF',
            preview:            'Pré-visualização',
            principal:          'Principal',
            published:          'Publicado',
            remove:             'Remover',
            schedule:           'Agendar',
            schedule_to:        'Agendado',
            seo_config:         'Configuração SEO',
            seo_description:    'Descrição SEO',
            seo_description_placeholder: 'Introduza a descrição SEO',
            seo_keywords:       'Palavras-chave SEO ',
            seo_keywords_small: '(separar por vírgulas)',
            seo_keywords_placeholder: 'Introduza as palavras-chave',
            seo_title:          'Título SEO',
            seo_title_placeholder: 'Introduza o título SEO',
            source_text:        'Fonte',
            source_image:       'Foto',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_date_published: 'Data de publicação',
            table_date_modified: 'Data de alteração',
            table_state:        'Estado',
            table_actions:      'Ações',
            text:               'Corpo da notícia',
            title:              'Título',
            title_placeholder:  'Introduza o título',
            save:               'Salvar',     
            subtitle:           'Resumo',
            subtitle_placeholder:  'Introduza o resumo',                
            youtube_choose:      'Youtube',   
            upload_file_error:  'O ficheiro tem mais de 10MB.',
        },
    'en':
        {
            add_new:            'Add new',
            archive:            'Archive',
            avaiable:           'Available until',
            abstract:           'Byline',
            cancel:             'Cancel', back: 'Voltar',
            close:              'Close',
            content:            'Press',
            content_add:        'Add block',
            choose_category:    'Press enter to add new tag',
            content_edit:       'Edit content',
            content_new:        'New content',
            content_list:       'Press list',
            dates:              'Dates',
            date_creation:      'Creation',
            date_avaiable:      'Avaiable until',
            date_publication:   'Publication',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            description:        'Description',
            draft:              'Draft',
            doc_choose:         'Choose PDF',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Search',
            id:                 'ID',
            layout:             'Type',
            multimedia:         'Multimedia',
            name:               'Name',
            name_placeholder:   'Insert the name',
            news:               'Press',
            news_add:           'Add block',
            news_edit:          'Edit article',
            news_new:           'New article',
            news_list:          'Press List',
            image:              'Highlight image',
            images:             'Images',
            image_choose:       'Choose image',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            page_config:        'Page config',
            page_parent:        'Parent',
            pages:              'Pages',
            pdf_documents:      'PDF Documents',
            preview:            'Preview',
            principal:          'Principal',
            published:          'Publicado',
            remove:             'Remove',
            schedule:           'Schedule',            
            schedule_to:        'Schedule', 
            seo_config:         'SEO config',
            seo_description:    'SEO description',
            seo_description_placeholder: 'Insert the SEO description',
            seo_keywords:       'SEO keywords',
            seo_keywords_small: '(separate by comma)',
            seo_keywords_placeholder: 'Insert the SEO keywords',
            seo_title:          'SEO title',
            seo_title_placeholder: 'Insert the SEO title',
            source_text:        'Source',
            source_image:       'Photo',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_date_published: 'Published date',
            table_date_modified: 'Modified date',
            table_state:        'State',
            table_actions:      'Actions',
            text:               'News Body',
            title:              'Title',
            title_placeholder:  'Insert title',
            save:               'Save',
            subtitle:           'Abstract',
            subtitle_placeholder:  'Insert abstract',  
            youtube_choose:      'Youtube',   
            upload_file_error:  'O ficheiro tem mais de 10MB.',
        }
}

module.exports = {
    language
};